import { useSearchParams } from "react-router";

export const useStatusOverrides = () => {
  const [searchParams] = useSearchParams();

  return {
    overall: searchParams.get("overallStatus") || null,
    sandbox: searchParams.get("sandboxStatus") || null,
    timeout: searchParams.get("timeoutStatus") || null,
  };
};
